(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('translateReferencesFilter', translateReferences);

    /** @ngInject */
    function translateReferences($translate) {
        return function(text) {
			switch (text) {
				case '24H':
					return $translate.instant("DAILY_TIME");
				case 'ILL_24H':
					return $translate.instant("DAILY_TIME");
				case 'VAC_24H':
					return $translate.instant("DAILY_TIME");
				case 'START':
					return $translate.instant("START");
				case 'STOP':
					return $translate.instant("STOP");
				case 'ILL_START':
					return $translate.instant("START");
				case 'ILL_STOP':
					return $translate.instant("STOP");
				case 'VAC_START':
					return $translate.instant("START");
				case 'VAC_STOP':
					return $translate.instant("STOP");
				default:
					return text;
			}
		};

    }

})();
